<script setup>
/* Imports */
import { computed } from 'vue';
import EmsFilters from './EmsFilters.vue';
import ColorPicker from './ColorPicker.vue';
import EmsOptionPicker from './EmsOptionPicker.vue';
import EmsModelPicker from './EmsModelPicker.vue';

// EMS TODO - Remove after we remove the ITFE_PRODUCT_PAGE_ENABLE_REUSABLE_EMS_UI feature flag
const enableReusableEMSUI = computed(() => window?.envSettings.ITFE_PRODUCT_PAGE_ENABLE_REUSABLE_EMS_UI);
</script>

<template>
  <template v-if="enableReusableEMSUI">
    <div class="new-ems">
      <p>Based on New EMS API</p>
      <EmsOptionPicker />
      <EmsModelPicker />
    </div>
    <div class="old-ems">
      <p>Based on Bootstrap EMS Data</p>
      <EmsFilters />
      <ColorPicker />
    </div>
  </template>
  <template v-else>
    <EmsFilters />
    <ColorPicker />
  </template>
</template>

<style lang="scss" scoped>
// EMS TODO - Remove after we remove the ITFE_PRODUCT_PAGE_ENABLE_REUSABLE_EMS_UI feature flag
/* stylelint-disable */
.new-ems {
  margin: 1rem 0;
  border: 2px solid red;
}

.old-ems {
  margin: 1rem 0;
  border: 2px solid blue;
}
</style>
